// Performance marks for the end-to-end measurements (keystroke → paint, another device's change → paint), made only
// when this browser asks for them (`localStorage['ws:perf'] = '1'`), so a long writing session never fills the
// performance timeline. `ws:remote` when another device's entry arrives, `ws:rebuild` (a measure) when the project is
// rebuilt, `ws:commit` when React has drawn it, `ws:painted` after the frame that shows it.
let on: boolean | null = null;

export function perfOn(): boolean {
  if (on === null) {
    try {
      on = typeof localStorage !== 'undefined' && localStorage.getItem('ws:perf') === '1' && typeof performance?.mark === 'function';
    } catch {
      on = false;
    }
  }
  return on;
}

export function perfMark(name: string, detail?: unknown) {
  if (perfOn()) performance.mark(name, detail === undefined ? undefined : { detail });
}

export function perfMeasure(name: string, start: number, detail?: unknown) {
  if (perfOn()) performance.measure(name, { start, end: performance.now(), ...(detail === undefined ? {} : { detail }) });
}

/** Marks `ws:painted` after the next frame is presented (a task queued from the frame's callback runs after it). */
export function markAfterPaint(detail?: unknown) {
  if (!perfOn() || typeof requestAnimationFrame === 'undefined') return;
  requestAnimationFrame(() => setTimeout(() => perfMark('ws:painted', detail), 0));
}
